import React from "react";
import verticalSpacing from "utils/generate-vertical-spacing";
import { useSelector } from "react-redux";

import hero from "components/hero";
import sliderHero from "components/slider-hero";
import swipeableHeader from "components/swipeable-header";
import richTextModule from "components/rich-text";
import timeline from "components/timeline";
import productFeatures from "components/product-features";
import animatedImagesWithText from "components/images-with-text";
import testimonials from "components/testimonials";
import slider from "components/slider";
import productSlider from "components/product-slider";
import blogHighlights from "components/blog-highlights";
import instaGallery from "components/insta-gallery";
import newsletter from "components/newsletter";
import heroText from "components/hero-text";
import logoList from "components/logo-list";
import threeColumnsText from "components/three-columns-text";
import promoBlock from "components/promo-block";
import contentAccordion from "components/content-accordion";
import productSingle from "components/product-single";
import imageReviews from "components/image-reviews";
import headerBar from "components/header-bar";
import textArea from "components/text-area";
import reviewsSection from "components/reviews-section";
import imageTestimonials from "components/image-testimonials";
import singleImageText from "components/single-image-text";
import storeReviews from "components/store-reviews";
import jobPosting from "components/job-posting";
import tabsModule from "components/tabs-module";
import referFriend from "components/refer-friend";
import imageCaption from "components/image-caption";
import floatingReviewsWidget from "components/floating-reviews-widget";
import iframe from "components/iframe";
import orderTracking from "components/order-tracking";
import backgroundImage from "components/background-image";
import productReviewsSection from "components/product-reviews-section";
import tasteGraph from "components/taste-graph";
import collectionModule from "components/collection";
import ugcReviewsModule from "components/ugc-reviews-module";
import imageLinkSlider from "components/image-slider";
import subscriptionDiscounts from "components/subscription-discounts";
import productBundleSection from "components/product-bundle";
import stackTextImage from "components/stack-text-image";
import subscriptionCockpit from "components/subscription-cockpit";
import videoSlider from "components/video-slider";
import expertQuote from "components/expert-quote";
import quizSection from "components/quiz-section";
import typeform from "components/typeform";
import bundleCurator from "components/bundle-curator";
import bundleWithVariants from "components/bundle-with-variants";
import flowRewardBanner from "components/flow-reward-banner";
import expertQuotesSlider from "components/expert-quote/slider";
import imagesAccordion from "components/images-accordion";
import flexibleImageHeader from "components/flexible-header-image";
import gorgiasHelpCenter from "components/gorgias-help-center";
import { getRgba } from "helpers/get-rgba";
import clsx from "clsx/lite";

const _module2Component = {
	hero,
	sliderHero,
	swipeableHeader,
	richTextModule,
	timeline,
	tabsModule,
	productFeatures,
	animatedImagesWithText,
	testimonials,
	slider,
	productSlider,
	blogHighlights,
	instaGallery,
	newsletter,
	heroText,
	logoList,
	threeColumnsText,
	promoBlock,
	contentAccordion,
	productSingle,
	imageReviews,
	reviewsSection,
	headerBar,
	textArea,
	imageTestimonials,
	singleImageText,
	storeReviews,
	jobPosting,
	referFriend,
	imageCaption,
	floatingReviewsWidget,
	iframe,
	orderTracking,
	backgroundImage,
	productReviewsSection,
	tasteGraph,
	collectionModule,
	ugcReviewsModule,
	imageLinkSlider,
	subscriptionDiscounts,
	productBundleSection,
	stackTextImage,
	subscriptionCockpit,
	videoSlider,
	expertQuote,
	quizSection,
	typeform,
	bundleCurator,
	bundleWithVariants,
	flowRewardBanner,
	expertQuotesSlider,
	imagesAccordion,
	flexibleImageHeader,
	gorgiasHelpCenter
};

const Module = ({ content, settings, className, ...other }) => {
	const RequestedModule = _module2Component[content._type];
	const { hideIfLoggedIn = false, hideIfOrders = false, hideIfSubs = false } = settings ?? {};
	const { orders, authenticated } = useSelector((state) => state.account.profile);
	const { subscriptionId } = useSelector((state) => state.account.subscription);

	if ((hideIfLoggedIn && authenticated) ||
		(hideIfOrders && orders.data.length > 0) ||
		(hideIfSubs && subscriptionId)) return null;

	const isUgcReviewsModule = content._type === "ugcReviewsModule";

	if (RequestedModule)
		return (
			<section
				style={{ backgroundColor: getRgba(settings?.bgColor) }}
				className={clsx(
					className, verticalSpacing(settings?.verticalSpace),
					settings?.bgColor?.hex && (isUgcReviewsModule ? "py-6 md:py-4" : "py-3 md:py-6"),
					settings?.roundedCorners && "module-rounded",
					settings?.constrainedWidth && "w-11/12 md:w-3/4 mx-auto !max-w-none",
					// If the module has a background color, make it full width
					className && settings?.bgColor?.hex && !settings?.constrainedWidth && "!w-full",
				)}
				id={settings?.id ?? null}
			>
				<RequestedModule data={content} {...other} />
			</section>
		);

	return <span></span>;
};

export default Module;